"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  DEFAULT_CHANNEL: "/",
  SYSTEM_CHANNEL: "postal",
  enableSystemMessages: true,
  cacheKeyDelimiter: "|",
  autoCompactResolver: false
};
exports.default = _default;